import classNames from 'classnames';
import React from 'react';

import Sidebar, { Tab } from 'sharedreact/components/Sidebar';

type Props = {
  className?: string,
  originId?: string,
  listClassName?: string,
  title?: string,
  children?: React.ReactNode,
  tabs?: Tab[],
  activeTab: number,
  noActiveTabName?: string,
  hideSidebar?: boolean,
  hideIsoCollapse?: boolean,

  onSelectTab: (activeTab: number) => void,
  renderExtraContent?: () => React.ReactNode,
  onHideSidebar?: () => void
};

class SidebarLayout extends React.Component<Props> {
  override render (): React.ReactNode {
    const {
      className, originId, listClassName, title, children, tabs, activeTab, hideSidebar, onHideSidebar,
      noActiveTabName, onSelectTab, hideIsoCollapse, renderExtraContent
    } = this.props;

    return (
      hideSidebar != null && hideSidebar === true
      ? <div id={originId} className='esko_tabs'>
        {children}
      </div>
      : <div className={classNames('esko_sidebarlayout', className)}>
        <Sidebar
          listClassName={listClassName}
          title={title}
          tabs={tabs}
          onSelectTab={onSelectTab}
          activeTab={activeTab}
          noActiveTabName={noActiveTabName}
          hideIsoCollapse={hideIsoCollapse}
          onHideSidebar={onHideSidebar}
          renderExtraContent={renderExtraContent}
        />
        <div id={originId} className='esko_tabs'>
          {children}
        </div>
      </div>
    );
  }
}

export default SidebarLayout;
